import StorageHelper from '../../utils/StorageHelper';
import { STORAGE_KEYS } from '../../configs/AppConfig';

export const getCompanyList = state => state.company.companies;
export const getQueriesPaging = state => state.company.queries;
export const getTotal = state => state.company.total;
export const getTotalPages = state => state.company.totalPages;

export const getSelected = state => state.company.selected;

export const getCompanyDetail = state => state.company.companyDetail;
export const getCompanyDomain = state => state.company.companyDomain || StorageHelper.getSessionItem(STORAGE_KEYS.domain);
export const getEndUserCompanyDetail = state => state.company.endUserCompanyDetail;
